import { useCallback, useEffect, useMemo, useState } from "react";

export function usePlanState(planOptions, billingPeriod, onInit) {
  const findPlanByBillingPeriod = useCallback(
    (period) => {
      if (!period) return planOptions?.[0];

      return (
        planOptions?.find((plan) => {
          return plan?.pricing?.billingPeriod === period;
        }) || planOptions?.[0]
      );
    },
    [planOptions]
  );

  const initialPlan = useMemo(() => {
    return findPlanByBillingPeriod(billingPeriod);
  }, [findPlanByBillingPeriod, billingPeriod]);

  const [s, set] = useState(initialPlan);

  useEffect(() => {
    const newSelectedPlan = findPlanByBillingPeriod(billingPeriod);
    set(newSelectedPlan);
    onInit(newSelectedPlan);
  }, [planOptions, billingPeriod, findPlanByBillingPeriod, onInit]);

  return [s, set];
}

export default usePlanState;
